<template>
  <section class="practice">
    <div class="row">
      <aside class="col-md-3 col-sm-12 cus-sidebar">
        <practiceSidebar />
      </aside>

      <div id="content" class="content col-md-9 col-sm-12 calendly-page">
        <div class="material-box bg-white">
          <div class="col-md-12 top-title">
            <h3>Calendly Events Links</h3>
          </div>

          <div class="col-md-12">
            <ShareBookingLink />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import practiceSidebar from "./components/Sidebar.vue";
import ShareBookingLink from "@/components/Calendly/ShareBookingLink.vue";

export default {
  name: "CalendlyIntegration",
  components: {
    practiceSidebar,
    ShareBookingLink,
  },
};
</script>

<style scoped>
.calendly-page {
  font-family: "Calibri", "Segoe UI", Arial, sans-serif;
}

.top-title h3 {
  color: #305397;
  font-family: "Calibri", sans-serif;
  font-size: 21px;
  font-weight: 600;
  margin: 0;
  padding: 8px 0 15px;
  border-bottom: 1px solid #e6e8ea;
  width: 100%;
}

</style>
